import React, { useState } from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import moment from 'moment';
import {
  CalendarContainer,
  CalendarHeader,
  CalendarGrid,
  NavigationButton,
  MonthYearTitle,
} from './styled';

const ModernCalendar = ({ value, onChange, disabledDate, isDateBlocked }) => {
  const [currentMonth, setCurrentMonth] = useState(moment());
  
  const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  
  const goToPrevMonth = () => {
    setCurrentMonth(currentMonth.clone().subtract(1, 'month'));
  };
  
  const goToNextMonth = () => {
    setCurrentMonth(currentMonth.clone().add(1, 'month'));
  };
  
  const generateCalendarDays = () => {
    const startOfMonth = currentMonth.clone().startOf('month');
    const endOfMonth = currentMonth.clone().endOf('month');
    const startOfCalendar = startOfMonth.clone().startOf('week');
    const endOfCalendar = endOfMonth.clone().endOf('week');
    
    const days = [];
    const current = startOfCalendar.clone();
    
    while (current.isSameOrBefore(endOfCalendar)) {
      days.push(current.clone());
      current.add(1, 'day');
    }
    
    return days;
  };
  
  const handleDayClick = (day) => {
    if (disabledDate && disabledDate(day)) {
      return;
    }
    
    if (day.month() !== currentMonth.month()) {
      return;
    }
    
    onChange(day);
  };
  
  const days = generateCalendarDays();
  
  return (
    <CalendarContainer>
      <CalendarHeader>
        <NavigationButton 
          icon={<LeftOutlined />} 
          onClick={goToPrevMonth}
        />
        <div style={{ textAlign: 'center' }}>
          <MonthYearTitle>
            {currentMonth.format('MMMM YYYY')}
          </MonthYearTitle>
          <div style={{ fontSize: '12px', color: '#8c8c8c', marginTop: '4px', fontWeight: '400' }}>
            Central Time (CST/CDT)
          </div>
        </div>
        <NavigationButton 
          icon={<RightOutlined />} 
          onClick={goToNextMonth}
        />
      </CalendarHeader>
      
      <CalendarGrid>
        <div className="calendar-weekdays">
          {weekdays.map(day => (
            <div key={day} className="weekday">
              {day}
            </div>
          ))}
        </div>
        
        <div className="calendar-days">
          {days.map(day => {
            const isSelected = value && day.isSame(value, 'day');
            const isToday = day.isSame(moment(), 'day');
            const isDisabled = disabledDate && disabledDate(day);
            const isOtherMonth = day.month() !== currentMonth.month();
            const isBlocked = isDateBlocked && isDateBlocked(day);
            
            let className = 'calendar-day';
            if (isSelected) className += ' selected';
            if (isToday) className += ' today';
            if (isDisabled) className += ' disabled';
            if (isBlocked && !isOtherMonth) className += ' blocked';
            if (isOtherMonth) className += ' other-month';
            
            return (
              <div
                key={day.format('YYYY-MM-DD')}
                className={className}
                onClick={() => handleDayClick(day)}
              >
                <div className="day-number">{day.format('D')}</div>
              </div>
            );
          })}
        </div>
      </CalendarGrid>
    </CalendarContainer>
  );
};

export default ModernCalendar;
